export const FEATURES = {
  appointment: {
    feature_id: 1000,
    feature_name: "Appointment",
    feature_path: "/sidebar",
    displayName: "Appointment",
    description:
      "Schedule appointments for patients to meet with healthcare providers at specified times.",
  },
  injuryNumber: {
    feature_id: 1001,
    feature_name: "injuryNumber",
    feature_path: "/appointment",
    displayName: "Injury Number",
    description:
      "Record and manage injury numbers associated with patient medical records for accurate tracking and reporting.",
  },
  ipdNumber: {
    feature_id: 1002,
    feature_name: "ipdNumber",
    feature_path: "/appointment",
    displayName: "IPD Number",
    description:
      "Assign and manage IPD (In-Patient Department) numbers for hospitalized patients for efficient patient management and billing.",
  },
  opdNumber: {
    feature_id: 1003,
    feature_name: "opdNumber",
    feature_path: "/appointment",
    displayName: "OPD Number",
    description:
      "Assign and manage OPD (Out-Patient Department) numbers for patients visiting healthcare facilities for outpatient services.",
  },
  institutionAccept: {
    feature_id: 1004,
    feature_name: "institutionAccept",
    feature_path: "/appointment",
    displayName: "Institution Accept",
    description:
      "Accept and process requests from healthcare institutions for appointments, treatments, or consultations.",
  },
  endConsultation: {
    feature_id: 1005,
    feature_name: "End Consultation",
    feature_path: "/appointment",
    displayName: "End Consultation",
    description: "End consultation.",
  },
  preConsultation: {
    feature_id: 1006,
    feature_name: "Pre-Consultation",
    feature_path: "/appointment",
    displayName: "Pre Consultation",
    description: "Pre consultation.",
  },
  consultation: {
    feature_id: 1500,
    feature_name: "Consultation",
    feature_path: "/sidebar",
    displayName: "Consultation",
    description:
      "Engage in professional discussions and provide medical advice to patients during consultation sessions.",
  },
  finance_and_accounting: {
    feature_id: 2000,
    feature_name: "Finance and Accounting",
    feature_path: "/sidebar",
    displayName: "Finance and Accounting",
    description:
      "Manage financial transactions, including billing, invoicing, payments, and accounting activities within the healthcare organization.",
  },
  consultation_fields: {
    feature_id: 2001,
    feature_name: "Consultation Fields",
    feature_path: "/finance and accounting",
    displayName: "Diagnosis & Treatment",
    description:
      "Configure and manage fields related to consultations, including diagnosis and treatment to ensure accurate and efficient documentation of patient interactions.",
  },
  setup: {
    feature_id: 2500,
    feature_name: "Setup",
    feature_path: "/sidebar",
    displayName: "Setup",
    description:
      "Configure and customize various system settings and preferences to tailor the application to the specific needs of the healthcare facility.",
  },
  doctor_clinic_setup: {
    feature_id: 2501,
    feature_name: "Doctor / Clinic setup",
    feature_path: "/setup",
    displayName: "Doctor / Clinic Setup",
    description:
      "Set up and manage details related to doctors and clinics, including their profiles, specialties, schedules, and contact information.",
  },
  consultation_setup: {
    feature_id: 2502,
    feature_name: "Consultation setup",
    feature_path: "/setup",
    displayName: "Consultation Setup",
    description:
      "Configure consultation-related settings, such as appointment types, duration, availability, and rules for scheduling appointments.",
  },
  medicine_setup: {
    feature_id: 2503,
    feature_name: "Medicine setup",
    feature_path: "/setup",
    displayName: "Medicine Setup",
    description:
      "Set up and manage medicine-related data, including inventory, prescriptions, dosages, and interactions, for effective patient care.",
  },
  customer_master: {
    feature_id: 2504,
    feature_name: "customer master",
    feature_path: "/setup",
    displayName: "Customer Master",
    description:
      "Manage customer information and profiles, including patient demographics, medical histories, and contact details, for personalized healthcare services.",
  },
  service_setup: {
    feature_id: 2505,
    feature_name: "Service setup",
    feature_path: "/setup",
    displayName: "Service Setup",
    description:
      "Configure service-related settings, such as service offerings, prices, packages, and discounts, to provide comprehensive healthcare solutions.",
  },
  language_model: {
    feature_id: 2506,
    feature_name: "Language model",
    feature_path: "/setup",
    displayName: "Language Model",
    description:
      "Set up and customize language models and translation services to facilitate communication with patients and healthcare providers in multiple languages.",
  },
  template_setup: {
    feature_id: 2507,
    feature_name: "Template setup",
    feature_path: "/setup",
    displayName: "Template Setup",
    description:
      "Create and customize templates for various documents, reports, forms, and communication materials used within the healthcare organization.",
  },
  consultation_master_data: {
    feature_id: 2508,
    feature_name: "Consultation master data",
    feature_path: "/setup",
    displayName: "Consultation Master Data",
    description:
      "Manage and maintain master data related to consultations, including diagnoses, treatments, procedures, and outcomes, for reference and analysis.",
  },
  header_and_footer_setup: {
    feature_id: 2509,
    feature_name: "Header and footer setup",
    feature_path: "/setup",
    displayName: "Header and Footer Setup",
    description:
      "Customize and configure headers and footers for documents, reports, forms, and other printed or digital materials used within the healthcare organization.",
  },
  tv_view_setup: {
    feature_id: 2510,
    feature_name: "TV view setup",
    feature_path: "/setup",
    displayName: "TV View Setup",
    description:
      "Set up and configure TV displays to provide informative and engaging content, such as announcements, health tips, and promotional messages, to patients and visitors.",
  },
  billing_setup: {
    feature_id: 2511,
    feature_name: "Billing setup",
    feature_path: "/setup",
    displayName: "Billing Setup",
    description:
      "Configure billing-related settings, such as insurance policies, payment methods, billing cycles, and reimbursement procedures, to streamline the billing process and ensure accurate financial transactions.",
  },
  groups_setup: {
    feature_id: 2512,
    feature_name: "Groups setup",
    feature_path: "/setup",
    displayName: "Groups Setup",
    description:
      "Set up and manage user groups and permissions to control access to system features and data based on roles and responsibilities within the healthcare organization.",
  },
  general_setup: {
    feature_id: 2513,
    feature_name: "General setup",
    feature_path: "/setup",
    displayName: "General Setup",
    description:
      "Configure general system settings and preferences, such as time zones, date formats, system language, and default values, to optimize user experience and system performance.",
  },
  logs: {
    feature_id: 2514,
    feature_name: "Notification Logs",
    feature_path: "/setup",
    displayName: "Notification Logs",
    description:
      "Track and review notification logs to monitor alerts and messages sent to patients.",
  },
  inventory: {
    feature_id: 2515,
    feature_name: "Inventory",
    feature_path: "/setup",
    displayName: "Inventory",
    description:
      "Manage and track inventory levels of medical supplies, equipment, and medications within the healthcare facility to ensure optimal stock levels and prevent shortages.",
  },
  testAndInvestigation: {
    feature_id: 2516,
    feature_name: "test-and-investigation",
    feature_path: "/setup",
    displayName: "Test And Investigation",
    description:
      "Organize and manage test and investigation procedures, including laboratory tests, imaging studies, and diagnostic assessments, to facilitate accurate diagnosis and treatment planning.",
  },
  creditAndTransaction: {
    feature_id: 2517,
    feature_name: "credit-and-transaction",
    feature_path: "/setup",
    displayName: "Credit And Transaction",
    description: "Credit and Transaction",
  },
  notificationSetup: {
    feature_id: 2518,
    feature_name: "notification",
    feature_path: "/setup",
    displayName: "Notification Setup",
    description: "Allow notification from here",
  },
  ipdSetup: {
    feature_id: 2519,
    feature_name: "IPD",
    feature_path: "/setup",
    displayName: "IPD Setup",
    description: "Set your IPD",
  },
  ItemSetup: {
    feature_id: 2520,
    feature_name: "Item",
    feature_path: "/setup",
    displayName: "Item Setup",
    description: "Setup your Items",
  },
  pharmacySetup: {
    feature_id: 2521,
    feature_name: "Pharmacy",
    feature_path: "/setup",
    displayName: "Pharmacy Setup",
    description: "Setup your Vendors",
  },
  vendorSetup: {
    feature_id: 2522,
    feature_name: "Vendor",
    feature_path: "/setup",
    displayName: "Vendor Setup",
    description: "Setup your Vendors",
  },
  warehouseSetup: {
    feature_id: 2523,
    feature_name: "Warehouse",
    feature_path: "/setup",
    displayName: "Warehouse & Logistic Setup",
    description: "Setup your warehouse",
  },
  workflowSetup: {
    feature_id: 2524,
    feature_name: "Workflow",
    feature_path: "/setup",
    displayName: "Workflow Setup",
    description: "Setup your workflow",
  },
  preconsultationSetup: {
    feature_id: 2525,
    feature_name: "Preconsultation",
    feature_path: "/setup",
    displayName: "Preconsultation Setup",
    description: "Setup your Preconsultation",
  },
  chat: {
    feature_id: 3000,
    feature_name: "Chat",
    feature_path: "/sidebar",
    displayName: "Chat",
    description:
      "Communicate and collaborate with patients, healthcare providers, and other stakeholders in real-time through text-based messaging for efficient information exchange and decision-making.",
  },
  notification: {
    feature_id: 3500,
    feature_name: "Notification",
    feature_path: "/sidebar",
    displayName: "Notification",
    description:
      "Receive timely updates, alerts, and reminders about appointments, test results, medication schedules, and other important events or activities within the healthcare organization.",
  },
  dashboard: {
    feature_id: 4000,
    feature_name: "Dashboard",
    feature_path: "/sidebar",
    displayName: "Dashboard",
    description:
      "Access and view comprehensive data summaries, analytics, and visualizations to monitor key performance indicators, track trends, and make informed decisions for effective healthcare management.",
  },
  settings: {
    feature_id: 4500,
    feature_name: "Settings",
    feature_path: "/sidebar",
    displayName: "Settings",
    description:
      "Access and customize application settings and preferences to personalize user experience, optimize workflow efficiency, and enhance system functionality within the healthcare environment.",
  },
  all_patient: {
    feature_id: 5000,
    feature_name: "All Patient",
    feature_path: "/sidebar",
    displayName: "All Patient",
    description:
      "View and manage comprehensive patient records and profiles, including demographics, medical histories, diagnoses, treatments, and appointments, for efficient patient care and communication.",
  },
  emergency: {
    feature_id: 6000,
    feature_name: "Emergency",
    feature_path: "/sidebar",
    displayName: "Emergency",
    description:
      "Access and manage critical emergency patient records and profiles swiftly, including demographics, medical histories, diagnoses, and treatments, ensuring prompt and effective care during urgent situations. Streamline workflows for seamless communication and coordination among healthcare providers.",
  },
  ipd: {
    feature_id: 7000,
    feature_name: "IPD",
    feature_path: "/sidebar",
    displayName: "IPD",
    description:
      "Manage and oversee all aspects of in-patient care, including admission, treatment plans, ongoing monitoring, and discharge processes. Facilitate efficient tracking of patient records, bed allocation, and multidisciplinary coordination to ensure seamless healthcare delivery. Enhance communication and streamline workflows for optimal patient outcomes in the hospital environment.",
  },
  pharmacy: {
    feature_id: 8000,
    feature_name: "Pharamcy",
    feature_path: "/pharamcy",
    displayName: "Pharmacy",
    description:
      "Manage all aspects of medication dispensing, inventory control, procurement, and prescription workflows, ensuring safe and efficient pharmaceutical operations within the healthcare organization.",
  },
};

export const checkPermission = (allowedFeatures, featureId) => {
  return allowedFeatures.includes(featureId);
};

export const createAppointment = (featureName) => {
  const subFeatures = Object.entries(FEATURES)
    .filter(
      ([key, value]) =>
        key !== featureName && value.feature_path === "/bookappointment"
    )
    .map(([key, value]) => value);

  return {
    name: featureName,
    subFeatures,
  };
};
